import { invariant } from 'folio-common-utils';
export function needsToSignForPromotion(currentType, proposedType) {
  if (proposedType === 'ExternalPaymentAccountant') {
    return true;
  }
  if (proposedType !== 'CFO' && proposedType !== 'Administrator') {
    return false;
  }
  if (currentType === 'CFO' || currentType === 'Administrator') {
    return false;
  }
  return true;
}
function isPromotion(fromType, toType) {
  if (toType === 'Administrator') {
    return true;
  }
  if (fromType === 'Administrator') {
    return false;
  }
  if (toType === 'CFO') {
    return true;
  }
  if (fromType === 'CFO') {
    return false;
  }
  if (toType === 'AccountantManager') {
    return true;
  }
  if (fromType === 'AccountantManager') {
    return false;
  }
  if (toType === 'Observer') {
    return true;
  }
  if (fromType === 'Observer') {
    return false;
  }
  if (toType === 'ExternalPaymentAccountant') {
    return true;
  }
  return false;
}
const textExplanationsPromoted = {
  Observer: {
    heading: 'Ny rolle',
    paragraph: 'Nå kan du se alle kjøp og bevegelser i {ORG_NAME}.'
  },
  AccountantManager: {
    heading: 'Ny rolle',
    paragraph: 'Nå kan du hente ut regnskapet, legge betalinger til godkjenning, og endre på informasjon om kjøp i {ORG_NAME}.'
  },
  ExternalPaymentAccountant: {
    heading: 'Du får beskjed når alt er klart!',
    paragraph: 'Vi bruker en arbeidsdag eller to på å skru på dine nye rettigheter og funksjoner i Folio.'
  },
  CFO: {
    heading: 'Du kan flytte pengene!',
    paragraph: 'Nå kan du gjøre betalinger og overføringer for {ORG_NAME}.'
  },
  Administrator: {
    heading: 'Alle rettigheter!',
    paragraph: 'Slå deg løs, nå administrerer du Folio for {ORG_NAME}.'
  },
  // you cannot be promoted to an employee, external accountant or invitee
  Employee: null,
  ExternalAccountant: null,
  Invitee: null,
  // these can never happen
  Free: null,
  CoFounder: null,
  HoldingPackageAccountant: null,
  Service: null,
  Unspecified: null
};
const textExplanationsDemoted = {
  Employee: {
    heading: 'Ny rolle',
    paragraph: 'Du har fått justert tilgang i Folio. Du kan fortsatt  legge til informasjon om egne kjøp, men ser ikke resten av bedriftens bevegelser.'
  },
  Observer: {
    heading: 'Ny rolle',
    paragraph: 'Du har fått justert tilgang i Folio. Du kan fortsatt se alle kjøp og bevegelser i bedriften.'
  },
  AccountantManager: {
    heading: 'Ny rolle',
    paragraph: 'Du har fått justert tilgang i Folio. Du kan fortsatt hente ut regnskapet, legge betalinger til godkjenning, og endre på informasjon om kjøp i {ORG_NAME}.'
  },
  CFO: {
    heading: 'Ny rolle',
    paragraph: 'Nå kan du gjøre betalinger og overføringer for {ORG_NAME}, men ikke legge til nye folk eller administrere andres tilganger.'
  },
  // you cannot be demoted to an administrator
  Administrator: null,
  // cannot be demoted from external accountants or invitee
  ExternalAccountant: null,
  ExternalPaymentAccountant: null,
  Invitee: null,
  // these can never happen
  Free: null,
  CoFounder: null,
  HoldingPackageAccountant: null,
  Service: null,
  Unspecified: null
};
const textExplanationsNewEmployee = {
  Employee: {
    heading: 'Velkommen til Folio!',
    paragraph: 'Kortet ditt er snart på vei.'
    // TODO: should link to app
    // paragraph: 'Kortet ditt er snart på vei. Mens du venter kan du skaffe deg appen.',
  },

  Observer: {
    heading: 'Velkommen til Folio!',
    paragraph: 'Nå kan du se alt som rører seg i bedriften. Kortet ditt er snart på vei.'
  },
  AccountantManager: {
    heading: 'Velkommen til Folio!',
    paragraph: 'Nå kan du se alt som rører seg i bedriften. Kortet ditt er snart på vei.'
  },
  CFO: {
    heading: 'Du kan flytte pengene!',
    paragraph: 'Nå kan du gjøre betalinger og overføringer for {ORG_NAME}.'
  },
  Administrator: {
    heading: 'Alle rettigheter!',
    paragraph: 'Slå deg løs, nå administrerer du Folio for {ORG_NAME}.'
  },
  // TODO: not sure these should be empty
  ExternalAccountant: null,
  ExternalPaymentAccountant: null,
  // these can never happen
  Free: null,
  CoFounder: null,
  Invitee: null,
  HoldingPackageAccountant: null,
  Service: null,
  Unspecified: null
};
export function getExplanation(promotion, needsToLogIn) {
  if (promotion.fromType == null) {
    if (promotion.state === 'Approval') {
      return {
        heading: 'Velkommen til Folio',
        paragraph: promotion.toType === 'Employee' ? 'Kortet ditt er snart på vei. Mens du venter kan du skaffe deg appen.' : promotion.toType === 'Observer' || promotion.toType === 'AccountantManager' ? 'Nå kan du se alt som rører seg i bedriften. Kortet ditt er snart på vei.' : 'Du kan snart gjøre betalinger og legge til andre. Vi gir lyd når alt er klart!'
      };
    }
  } else {
    if (promotion.state === 'AgentSigning') {
      if (needsToLogIn) {
        return {
          heading: 'Vi trenger en omstart!',
          paragraph: 'Systemet lugger. Logg inn på nytt for å fortsette. '
        };
      }
      return {
        heading: 'Signere avtalen',
        paragraph: 'For å gjøre betalinger eller sette opp integrasjoner, må du signere bankavtalen.'
      };
    }
    if (promotion.state === 'Approval') {
      return {
        heading: 'Du får beskjed når alt er klart!',
        paragraph: 'Vi bruker en arbeidsdag eller to på å skru på dine nye rettigheter og funksjoner i Folio.'
      };
    }
  }
  if (promotion.state === 'Done') {
    const explanation = promotion.fromType == null ? textExplanationsNewEmployee[promotion.toType] : isPromotion(promotion.fromType, promotion.toType) ? textExplanationsPromoted[promotion.toType] : textExplanationsDemoted[promotion.toType];
    invariant(explanation, `Completed promotion between ${promotion.fromType} and ${promotion.toType} has no text associated with it`);
    return explanation;
  }
  invariant(false, `Promotion state ${promotion.state} for ${promotion.fromType} to ${promotion.toType} is unexpected`);
}
//# sourceMappingURL=promotion.js.map